import { render, staticRenderFns } from "./selectActiveBranchModal.vue?vue&type=template&id=00866a80&"
import script from "./selectActiveBranchModal.vue?vue&type=script&lang=js&"
export * from "./selectActiveBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00866a80')) {
      api.createRecord('00866a80', component.options)
    } else {
      api.reload('00866a80', component.options)
    }
    module.hot.accept("./selectActiveBranchModal.vue?vue&type=template&id=00866a80&", function () {
      api.rerender('00866a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/selectActiveBranchModal.vue"
export default component.exports